import React from 'react'
import BaseIcon from 'react-icon-base'

const AU = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 21 15" {...props}>
    <title>AU</title>
    <defs>
      <rect id="a" width="21" height="15" rx="2" />
      <filter id="b" width="104.8%" height="106.7%" x="-2.4%" y="-3.3%" filterUnits="objectBoundingBox">
        <feMorphology in="SourceAlpha" radius="1" result="shadowSpreadInner1" />
        <feOffset in="shadowSpreadInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.121659873 0" />
      </filter>
      <rect id="d" width="20" height="14" x=".5" y=".5" rx="1" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="c" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#1C36AD" xlinkHref="#a" />
      <use fill="#000" filter="url(#b)" xlinkHref="#a" />
      <path
        fill="#BDC4E7"
        d="M5 11v-1h1v1h1v1H6v1H5v-1H4v-1zM14 3v1h1V3h-1zm3 1v1h1V4h-1zm-4 2v1h1V6h-1zm3 1v1h1V7h-1zm-1 3v1h1v-1h-1z"
        mask="url(#c)"
      />
      <rect width="9" height="7" x="1" y="1" fill="#FFF" mask="url(#c)" rx="1" />
      <path
        fill="#D72342"
        d="M5 5H2V4h3V2h1v2h3v1H6v2H5V5zm2.5 1v1H9V6H7.5zm0-4v1H9V2H7.5zM2 6v1h1.5V6H2zm0-4v1h1.5V2H2z"
        mask="url(#c)"
      />
      <use stroke="#2F343A" strokeOpacity=".157" xlinkHref="#d" />
    </g>
  </BaseIcon>
)

export default AU
